import { ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import CloseIcon from './CloseIcon'

import { useWindowSize } from 'usehooks-ts'
import { party_colors } from 'components/MainComponent/party_colors'

interface Municipality {
  ORTNAME: string
  PLZ4: number
  PLZ6: number
  GDENAMK: string
  GDENR: number
  KTKZ: string
  NORMORTSNAME: string
  NORMGEMEINDE: string
}
const ToolTip: React.FC<{
  activeData: any
  currentName?: string
  propertyName?: string
  isClosable?: boolean
  hasShadow?: boolean
  closePressed?: () => void
}> = ({
  activeData,

  isClosable,
  hasShadow,
  closePressed,
}): ReactElement => {
  const [cOaSource, setCOaSource] = useState<string | undefined>()
  var locale = 'de'
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  useEffect(() => {
    setCOaSource(undefined)
    if (!activeData || !activeData.bfsId) return
    checkIfImageExists(
      'https://interaktiv.tagesanzeiger.ch/static/gemeindewappen/' +
        zeroPadBfsId(activeData.bfsId) +
        '.png',
      (exists) => {
        if (exists) {
          setCOaSource(
            'https://interaktiv.tagesanzeiger.ch/static/gemeindewappen/' +
              zeroPadBfsId(activeData.bfsId) +
              '.png'
          )
        } else {
          setCOaSource(undefined)
        }
      }
    )
  }, [ activeData.bfsId])

  const toolTipRef = useRef<HTMLDivElement>(null)

  if (!activeData) return <></>

  const { bfsId, id, results, strongest, viz, year, name_de } = activeData
  const maxValue = Math.max(
    ...Object.values(results)
      .filter((f) => f !== '.')
      .map(Number)
  )
  const tableEntryCount = Object.entries(results).filter(
    (f: any) => f[1] > 0
  ).length

  const halfCount = Math.ceil(tableEntryCount / 2)

  const twoCols = isClosable && tableEntryCount > halfCount && !isMobile

  return (
    <ToolTipWrapper
      static={isClosable === true}
      ref={toolTipRef}
      hasShadow={hasShadow}
      style={{
        minWidth: '250px',
        backgroundColor: isClosable ? 'transparent' : 'var(--site-background)',
        maxWidth: isClosable ? '668px' : '300px',
        boxShadow: isClosable ? 'none' : 'rgba(0, 0, 0, 0.2) 0px 5px 15px',
        // borderTop: isClosable ? '2px solid var(--gray-1)' : 'none',
        // borderRadius: isClosable ? '0' : '1rem',
      }}
    >
      {activeData && locale && (
        <>
          {
            <Head>
              {isClosable && (
                <ClosingButton
                  className='close-button'
                  onClick={(e) => {
                    e.stopPropagation()
                    closePressed?.()
                  }}
                >
                  <CloseIcon />
                </ClosingButton>
              )}
            </Head>
          }
          <Body>
            <GdeRow static={isClosable === true}>
              <div>
                <CodeOfArmsWrapper>
                  {cOaSource && <CodeOfArms src={cOaSource} />}
                </CodeOfArmsWrapper>
              </div>
              <TitleContainer>
                <Title>{name_de}</Title>
              </TitleContainer>
              <Sub>Nationalratswahl {year}</Sub>
            </GdeRow>
            <TableRow static={isClosable === true}>
              <ResultTable
                style={{
                  width: '100%',
                  marginRight: '0',
                }}
              >
                <tbody>
                  {(Object.entries(results) as [string, number][])
                    .filter((f) => f[1] > 0)
                    .sort((a, b) => b[1] - a[1])
                    // .slice(0, twoCols ? halfCount : tableEntryCount)
                    .map(([key, value], i) => {
                      return (
                        <tr key={'tooltiptable_' + i}>
                          <KeyCell className='left'>{key}</KeyCell>

                          <BarCell>
                            <Bar
                              style={{
                                width: (value * 100) / maxValue + 'px',
                                backgroundColor: party_colors[key],
                              }}
                            />
                          </BarCell>
                          <ValueCell>
                            {value == 0 && <>-</>}
                            {value > 0 &&
                              value.toFixed(1).replace('.', ',') + '%'}
                          </ValueCell>
                        </tr>
                      )
                    })}
                </tbody>
              </ResultTable>

              {/* {twoCols && (
                <ResultTable
                  style={{
                    width: isClosable ? 'calc(50% - 15px)' : '100%',
                  }}
                >
                  <tbody>
                    {(Object.entries(results) as [string, number][])
                      .filter((f) => f[1] > 0)
                      .sort((a, b) => b[1] - a[1])
                      .slice(halfCount)
                      .map(([key, value], i) => {
                        return (
                          <tr key={'tooltiptable_' + i}>
                            <KeyCell className='left'>{key}</KeyCell>

                            <BarCell>
                              <Bar
                                style={{
                                  width: (value * 100) / maxValue + 'px',
                                  backgroundColor: party_colors[key],
                                }}
                              />
                            </BarCell>
                            <ValueCell>
                              {value == 0 && <>-</>}
                              {value > 0 &&
                                value.toFixed(1).replace('.', ',') + '%'}
                            </ValueCell>
                          </tr>
                        )
                      })}
                    {(Object.entries(results) as [string, number][])
                      .filter((f) => f[1] > 0)
                      .slice(6).length < halfCount && (
                      <>
                        {[
                          ...Array(
                            halfCount -
                              (Object.entries(results) as [string, number][])
                                .filter((f) => f[1] > 0)
                                .slice(halfCount).length
                          ),
                        ].map((m) => {
                          return (
                            <tr>
                              <KeyCell className='left'></KeyCell>
                              <BarCell>
                                <Bar />
                              </BarCell>
                              <ValueCell></ValueCell>
                            </tr>
                          )
                        })}
                      </>
                    )}
                  </tbody>
                </ResultTable>
              )} */}
            </TableRow>
            {/* <HistoricalChartD3
              bfsid={activeData.bfsId}
              activeParty={"Schweiz"}
              activeYear={activeData.activeYear}
              // setActiveYear={setActiveYear}
              // setActiveParty={setActiveParty}
            /> */}
          </Body>
        </>
      )}
    </ToolTipWrapper>
  )
}

function zeroPadBfsId(bfsId: number) {
  return bfsId.toString().padStart(4, '0')
}
const checkIfImageExists = (
  url: string,
  callback: (exists: boolean) => void
) => {
  const img = new Image()
  img.src = url

  if (img.complete) {
    callback(true)
  } else {
    img.onload = () => {
      callback(true)
    }

    img.onerror = () => {
      callback(false)
    }
  }
}

const Bar = styled.div`
  width: 10px;
  height: 20px;
`
const GdeRow = styled.div.attrs({ className: 'GdeRow' })<{ static: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
  flex: 0 0 100%;
  border: 1px solid #f00;
`

const TableRow = styled.div<{ static: boolean }>`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-width: ${(props) => (props.static ? '260px' : '100%')};
  border: 1px solid #f00;
`

const CodeOfArmsWrapper = styled.div`
  min-width: 60px;
  min-height: 50px;
  display: flex;
  justify-content: flex-start;
`
const CodeOfArms = styled.img`
  width: auto;
  max-width: 50px;
`
const TitleContainer = styled.div`
  flex: 0 0 calc(100% - 80px);
  justify-content: center;
`

const Title = styled.div`
  width: 100%;
  font-size: 18px;
  text-align: left;
  font-weight: 700;
  line-height: 1.2em;
  padding-top: 10px;
`

const Sub = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 30px;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.2em;
`

const ResultTable = styled.table`
  font-size: 12px;
  table-layout: fixed;
  line-height: 12px;
  /*   
  margin-left: auto;
  margin-right: auto; */
  tr {
    line-height: 10px;
    height: 10px;
    max-height: 10px;
    overflow: hidden;
  }
`
const KeyCell = styled.td`
  text-align: left;
  font-size: 13px;
  /* padding-left: 5px; */
  border-bottom: 1px solid #b4b4b4;
`

const BarCell = styled.td`
  width: 100px;
  border-bottom: 1px solid #b4b4b4;
`
const ValueCell = styled.td`
  text-align: right;
  padding-right: 5px;
  /* width: 40px; */
  font-weight: 700;
  padding: 4px;
  border-bottom: 1px solid #b4b4b4;
`

const Head = styled.div`
  display: flex;
  justify-content: flex-end;
  /* margin: 1em;
  margin-bottom: 0; */
  h4 {
    font-size: 1em;
    font-weight: 400;
    margin: 0;
    text-align: center;
    width: 100%;
  }
`
const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */
  margin: 1em;
  margin-top: 0;
`
const Row = styled.div`
  font-size: 1.3em;
  &.sub {
    font-size: 1em;
  }
`

const ClosingButton = styled.button`
  pointer-events: all;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.5rem;
  border: none;
  background-color: transparent;
  // disable flashing when pressing button
  -webkit-tap-highlight-color: transparent;
  color: inherit;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: var(--color-black);
    color: var(--color-white);
  }
`

export const ToolTipWrapper = styled.div.attrs({ className: 'TT' })<{
  hasShadow?: boolean
  static: boolean
}>`
  pointer-events: all;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
  /* display: flex; */
  /* flex-direction: ${(props) => (props.static ? 'column' : 'row')}; */
  text-align: center;
  border-radius: 1rem;
  font-size: 14px;
  font-family: var(--font-sans-serif);
`
export default ToolTip
